export const translations = {
  en: {
    // Header
    roomSelection: "Room Selection",
    yourSearchDetails: "Your Search Details",
    checkInOut: "Check-in / Check-out",
    guests: "Guests",
    rooms: "Rooms",
    adults: "adults",
    children: "children",
    room: "room(s)",
    
    // Best Price Banner
    bestPriceGuarantee: "Best Price Guarantee!",
    bookDirectly: "Book directly on our website for the best rates and exclusive benefits.",
    
    // Room List
    availableRooms: "Available Rooms",
    sortBy: "Sort by",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    noRoomsAvailable: "No rooms available for the selected dates.",
    tryDifferentDates: "Please try different dates or contact us for assistance.",
    
    // Room Card
    withBreakfast: "With Breakfast",
    withoutBreakfast: "Room Only",
    extraBenefit: "+ Extra Benefit",
    bestPrice: "Best Price",
    callForPrice: "Call for Price",
    includingTaxes: "Including taxes & fees",
    roomsAvailable: "rooms available",
    soldOut: "Sold Out",
    contactUs: "Contact Us",
    invalidPrice: "Invalid Price",
    select: "Select",
    selectBestPrice: "Select Best Price",
    roomFacilities: "Room Facilities",
    viewAll: "View all",
    viewLess: "View less",
    nonRefundable: "Non-refundable",
    
    // Calendar
    selectDates: "Select Dates",
    checkIn: "Check-in",
    checkOut: "Check-out",
    selectCheckInDate: "Select check-in date.",
    selectCheckOutDate: "Select the check-out date",
    done: "Done",
    close: "Close",
    
    // Unavailable Rooms
    roomsUnavailable: "Rooms Are Currently Unavailable",
    unavailableMessage: "We apologize, but the rooms you're looking for are currently unavailable for the selected dates or have no available rates.",
    suggestions: "Suggestions:",
    tryDifferentDates: "Try selecting different dates",
    adjustGuests: "Consider adjusting the number of guests",
    checkBackLater: "Check back later as availability may change"
  },
  id: {
    // Header
    roomSelection: "Pemilihan Kamar",
    yourSearchDetails: "Detail Pencarian Anda",
    checkInOut: "Check-in / Check-out",
    guests: "Tamu",
    rooms: "Kamar",
    adults: "dewasa",
    children: "anak",
    room: "kamar",
    
    // Best Price Banner
    bestPriceGuarantee: "Jaminan Harga Terbaik!",
    bookDirectly: "Pesan langsung di situs web kami untuk tarif terbaik dan manfaat eksklusif.",
    
    // Room List
    availableRooms: "Kamar Tersedia",
    sortBy: "Urutkan berdasarkan",
    priceLowToHigh: "Harga: Rendah ke Tinggi",
    priceHighToLow: "Harga: Tinggi ke Rendah",
    noRoomsAvailable: "Tidak ada kamar yang tersedia untuk tanggal yang dipilih.",
    tryDifferentDates: "Silakan coba tanggal yang berbeda atau hubungi kami untuk bantuan.",
    
    // Room Card
    withBreakfast: "Dengan Sarapan",
    withoutBreakfast: "Hanya Kamar",
    extraBenefit: "+ Manfaat Tambahan",
    bestPrice: "Harga Terbaik",
    callForPrice: "Hubungi untuk Harga",
    includingTaxes: "Sudah termasuk pajak & biaya",
    roomsAvailable: "kamar tersedia",
    soldOut: "Habis Terjual",
    contactUs: "Hubungi Kami",
    invalidPrice: "Harga Tidak Valid",
    select: "Pilih",
    selectBestPrice: "Pilih Harga Terbaik",
    roomFacilities: "Fasilitas Kamar",
    viewAll: "Lihat semua",
    viewLess: "Lihat lebih sedikit",
    nonRefundable: "Tidak bisa refund",
    
    // Calendar
    selectDates: "Pilih Tanggal",
    checkIn: "Check-in",
    checkOut: "Check-out",
    selectCheckInDate: "Pilih tanggal check-in.",
    selectCheckOutDate: "Pilih tanggal check-out",
    done: "Selesai",
    close: "Tutup",
    
    // Unavailable Rooms
    roomsUnavailable: "Kamar Saat Ini Tidak Tersedia",
    unavailableMessage: "Kami mohon maaf, tetapi kamar yang Anda cari saat ini tidak tersedia untuk tanggal yang dipilih atau tidak memiliki tarif yang tersedia.",
    suggestions: "Saran:",
    tryDifferentDates: "Coba pilih tanggal yang berbeda",
    adjustGuests: "Pertimbangkan untuk menyesuaikan jumlah tamu",
    checkBackLater: "Periksa kembali nanti karena ketersediaan mungkin berubah"
  },
  zh: {
    // Header
    roomSelection: "客房选择",
    yourSearchDetails: "您的搜索详情",
    checkInOut: "入住 / 退房",
    guests: "客人",
    rooms: "客房",
    adults: "成人",
    children: "儿童",
    room: "间客房",
    
    // Best Price Banner
    bestPriceGuarantee: "最优价格保证！",
    bookDirectly: "直接在我们的网站上预订，获取最优惠的价格和专属福利。",
    
    // Room List
    availableRooms: "可用客房",
    sortBy: "排序方式",
    priceLowToHigh: "价格：从低到高",
    priceHighToLow: "价格：从高到低",
    noRoomsAvailable: "所选日期没有可用客房。",
    tryDifferentDates: "请尝试选择不同的日期或联系我们获取帮助。",
    
    // Room Card
    withBreakfast: "含早餐",
    withoutBreakfast: "Room Only",
    extraBenefit: "+ 额外福利",
    bestPrice: "最优价格",
    callForPrice: "致电询价",
    includingTaxes: "已包含税费",
    roomsAvailable: "间客房可用",
    soldOut: "已售罄",
    contactUs: "联系我们",
    invalidPrice: "无效价格",
    select: "选择",
    selectBestPrice: "选择最优价格",
    roomFacilities: "客房设施",
    viewAll: "查看全部",
    viewLess: "收起",
    nonRefundable: "不可退款",
    
    // Calendar
    selectDates: "选择日期",
    checkIn: "入住",
    checkOut: "退房",
    selectCheckInDate: "选择入住日期。",
    selectCheckOutDate: "选择退房日期",
    done: "完成",
    close: "关闭",
    
    // Unavailable Rooms
    roomsUnavailable: "客房当前不可用",
    unavailableMessage: "我们很抱歉，您正在寻找的客房目前在所选日期不可用或没有可用价格。",
    suggestions: "建议：",
    tryDifferentDates: "尝试选择不同的日期",
    adjustGuests: "考虑调整客人数量",
    checkBackLater: "稍后再查看，因为可用性可能会变化"
  }
};

export default translations; 